import React from 'react';
import Style from './button.module.css';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const Button = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.name = props.name === undefined ? '' : props.name;
  propsArray.type = props.type === undefined ? 'button' : props.type;
  propsArray.value = props.value === undefined ? '' : props.value;
  propsArray.iconStart = props.iconStart === undefined ? '' : props.iconStart;
  propsArray.iconEnd = props.iconEnd === undefined ? '' : props.iconEnd;
  propsArray.disabled = props.disabled === undefined || props.disabled === false ? false : props.disabled;
  propsArray.variant = Style[props.variant === undefined ? 'filled' : props.variant];
  propsArray.color = Style[props.color === undefined ? 'success' : props.color];
  propsArray.size = Style[props.size === undefined ? 'md' : props.size];
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsxs(React.Fragment, {
      children: [propsArray.disabled === false && _jsxs("button", {
        onClick: props.onClick,
        name: propsArray.name,
        type: propsArray.type,
        value: propsArray.value,
        className: `${Style.button} ${propsArray.variant} ${propsArray.color} ${propsArray.size}`,
        css: emotionStyle,
        children: [propsArray.iconStart.split('.')[1] === undefined && _jsx("span", {
          className: propsArray.iconStart
        }), propsArray.iconStart !== undefined && propsArray.iconStart.split('.')[1] !== undefined && _jsx("img", {
          src: propsArray.iconStart,
          alt: "icon"
        }), props.children, propsArray.iconEnd.split('.')[1] === undefined && _jsx("span", {
          className: propsArray.iconEnd
        }), propsArray.iconEnd !== undefined && propsArray.iconEnd.split('.')[1] !== undefined && _jsx("img", {
          src: propsArray.iconEnd,
          alt: "icon"
        })]
      }), propsArray.disabled === true && _jsx("button", {
        onClick: props.onClick,
        className: `${Style.button} ${propsArray.size} ${Style.disabled}`,
        css: emotionStyle,
        children: props.children
      })]
    }), propsArray.className !== '' && _jsxs(React.Fragment, {
      children: [propsArray.disabled === false && _jsxs("button", {
        onClick: props.onClick,
        name: propsArray.name,
        type: propsArray.type,
        value: propsArray.value,
        className: `${Style.button} ${propsArray.variant} ${propsArray.color} ${propsArray.size} ${propsArray.className}`,
        css: emotionStyle,
        children: [propsArray.iconStart.split('.')[1] === undefined && _jsx("span", {
          className: propsArray.iconStart
        }), propsArray.iconStart !== undefined && propsArray.iconStart.split('.')[1] !== undefined && _jsx("img", {
          src: propsArray.iconStart,
          alt: "icon"
        }), props.children, propsArray.iconEnd.split('.')[1] === undefined && _jsx("span", {
          className: propsArray.iconEnd
        }), propsArray.iconEnd !== undefined && propsArray.iconEnd.split('.')[1] !== undefined && _jsx("img", {
          src: propsArray.iconEnd,
          alt: "icon"
        })]
      }), propsArray.disabled === true && _jsx("button", {
        onClick: props.onClick,
        type: propsArray.type,
        className: `${Style.button} ${propsArray.size} ${Style.disabled} ${propsArray.className}`,
        css: emotionStyle,
        children: props.children
      })]
    })]
  });
};

export default Button;